import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
export default function LandingPage(){
    const nav = useNavigate();
      useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== 'https://hourhive-landing.web.app') return;

      const { type, payload } = event.data;

      if (type === 'CALL_FUNCTION') {
        console.log('Function called from iframe!');
        myFunction(payload);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

    const myFunction = () => {
    nav('/login'); 
  };
    return(
        <div style={{width :"100%",height :"100vh",overflow :"hidden"}}>
              <iframe   sandbox="allow-scripts allow-same-origin" src="https://hourhive-landing.web.app" style={{width :"100%",height :"100%"}}></iframe>
        </div>
    )
}